import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const initialState = {
  isLogin: false,
  isLoading: false,
  isNotify: false,
  msg: "",
  isError: false,
};
const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(logOut.pending, (state) => {
        state.isLogin = false;
        state.msg = "";
      })
      .addCase(logOut.fulfilled, (state, action) => {
        if (action.payload === 1) {
          state.isLogin = false;
        }
      })
      .addCase(logOut.rejected, (state) => {
        state.msg = "";
      })

      .addCase(login.pending, (state) => {
        state.isLoading = true;
        state.msg = "";
      })
      .addCase(login.fulfilled, (state, action) => {
        if (action.payload.status === 1) {
          state.isLoading = false;
          state.msg = "";
          state.isLogin = true;
          return;
        }
        if (!action.payload.status) {
          state.isLoading = false;
          state.isLogin = false;
          state.isNotify = true;
          state.msg = action.payload.message;
        }
        state.isLoading = false;
        state.isLogin = false;
        state.isNotify = true;
        state.msg = action.payload.message;
      })
      .addCase(login.rejected, (state, action) => {
        state.isNotify = true;
        state.isLoading = false;
        state.msg = "Đăng nhập lỗi";
      });
  },
});

export default AuthSlice;

export const login = createAsyncThunk("auth/login", async (dataLogin) => {
  try {
    const res = await axios.post(
      `${window.SERVER_URL}/api/auth/login`,
      dataLogin,
      {
        withCredentials:
          window.WITHCREDENTIAL !== "undefined" ? window.WITHCREDENTIAL : true,
      }
    );

    if (res.status === 200) {
      localStorage.setItem("accessToken", res.data.data.token);
      localStorage.setItem("userInfor", res.data.data.username);
      if (res.data.data.type === 4) {
        localStorage.setItem("keyMenu", "storemanager");
      }
      return res.data;
    }
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
});
export const logOut = createAsyncThunk("auth/logOut", async () => {
  try {
    const res = await axios.put(`${window.SERVER_URL}/api/auth/logout`, null, {
      withCredentials:
        window.WITHCREDENTIAL !== "undefined" ? window.WITHCREDENTIAL : true,
    });
    return res.data.status;
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
});
